document.addEventListener('DOMContentLoaded', function () {
  const tabs = document.querySelectorAll('.tabs ul li a');
  const tabContents = document.querySelectorAll('.tab-contents .tab-pane');
  const carousel = document.querySelector('.tabs ul');

  const deactivateAllTabs = () => {
    tabs.forEach((tab) => tab.parentElement.classList.remove('active'));
    tabContents.forEach((content) => content.classList.remove('active'));
  };

  const scrollToTab = (tab) => {
    const tabPosition = tab.parentElement.offsetLeft;
    carousel.scrollTo({
      left: tabPosition,
      behavior: 'smooth',
    });
  };

  tabs.forEach((tab, index) => {
    tab.addEventListener('click', function (event) {
      event.preventDefault();
      deactivateAllTabs();
      tab.parentElement.classList.add('active');
      document.querySelector(tab.getAttribute('href')).classList.add('active');

      history.pushState(null, null, tab.getAttribute('href'));

      const sectionId = tab.getAttribute('data-section-id');
      document.dispatchEvent(
        new CustomEvent('need_update', {
          detail: { sectionId },
        })
      );

      scrollToTab(tab);
    });
  });

  function handleInitialHash() {
    if (window.location.hash) {
      const hash = window.location.hash;
      const activeTab = document.querySelector(`a[href="${hash}"]`);

      if (activeTab) {
        const isTabActive = activeTab.parentElement.classList.contains('active');

        if (!isTabActive) {
          deactivateAllTabs();
          activeTab.parentElement.classList.add('active');
          document.querySelector(activeTab.getAttribute('href')).classList.add('active');
          setTimeout(() => {
            scrollToTab(activeTab);
          }, 100);

          history.replaceState(null, null, hash);
        }
      }
    } else if (tabs.length > 0 && !window.location.hash) {
      deactivateAllTabs();
      tabs[0].parentElement.classList.add('active');
      document.querySelector(tabs[0].getAttribute('href')).classList.add('active');
    }
  }

  handleInitialHash();

  function setupModal() {
    const toggleButtons = document.querySelectorAll('.tutorial-modal__toggle');

    toggleButtons.forEach((button) => {
      button.addEventListener('click', function () {
        const modalContentWrapper = button.closest('details-modal').querySelector('.tutorial-modal__content--body');

        if (modalContentWrapper) {
          const body = document.querySelector('body');
          let existingModalContent = body.querySelector('.tutorial-modal__body');

          if (existingModalContent) {
            existingModalContent.remove();
          }

          const modalContentCopy = modalContentWrapper.cloneNode(true);
          modalContentCopy.classList.add('tutorial-modal__body');
          body.appendChild(modalContentCopy);
          modalContentCopy.style.display = 'block';

          const closeButton = modalContentCopy.querySelector('.icon-close');
          if (closeButton) {
            closeButton.addEventListener('click', function () {
              modalContentCopy.remove();
            });
          }
        }
      });
    });
  }

  function checkMobileAndSetup() {
    const isMobile = window.matchMedia('(max-width: 739px)').matches;

    if (isMobile) {
      setupModal();
    }
  }

  checkMobileAndSetup();
  window.addEventListener('resize', checkMobileAndSetup);
});
